module.exports = __webpack_public_path__ + "img/爱你.b097fb0e.gif";